import {
	EmailShareButton,
	FacebookShareButton,
	PinterestShareButton,
} from 'react-share';
import React from 'react';
import Social from './Social';
import SocialIcon from './SocialIcon';

class SocialShare extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			currentURL: null,
		};
	}

	componentDidMount() {
		this.setState({
			currentURL: window.location.href,
		});
	}

	render() {
		const { currentURL } = this.state;

		const printPage = () => {
			window.print();
		};

		if (this.props.contentType === 'home') {
			return (
				<div className="social-share">
					<EmailShareButton
						aria-label="Share This Page with Email"
						subject={this.props.title}
						url={currentURL}
						data-analytics={JSON.stringify({ name: 'email', module: 'share' }, null, 2)}
					>
						<SocialIcon type="email" alt="Share This Page with Email" />
					</EmailShareButton>
					<PinterestShareButton
						url={currentURL}
						// media={Social.pinterest.image}
						aria-label="Share This Page on Pinterest"
						data-analytics={JSON.stringify({ name: 'pinterest', module: 'share' }, null, 2)}
					>
						<SocialIcon type="pinterest" alt="Share This Page on Pinterest" />
					</PinterestShareButton>
					<button
						className="react-share__ShareButton"
						type="button"
						onClick={() => printPage()}
						aria-label="Print This Page"
						data-analytics={JSON.stringify({ name: 'print', module: 'share' }, null, 2)}
					>
						<SocialIcon type="print" alt="Print this page" />
					</button>
				</div>
			);
		}

		// Default For all other pages
		return (
			<div className="social-share">
				<FacebookShareButton
					url={currentURL}
					aria-label="Share This Page on Facebook"
					data-analytics={JSON.stringify({ name: 'facebook', module: 'share' }, null, 2)}
				>
					<SocialIcon type="facebook" alt="Share This Page on Facebook" />
				</FacebookShareButton>
				<PinterestShareButton
					url={currentURL}
					media={this.props.media}
					aria-label="Share This Page on Pinterest"
					data-analytics={JSON.stringify({ name: 'pinterest', module: 'share' }, null, 2)}
				>
					<SocialIcon type="pinterest" alt="Share This Page on Pinterest" />
				</PinterestShareButton>
				<EmailShareButton
					aria-label="Share This Page with Email"
					subject={this.props.title}
					url={currentURL}
					data-analytics={JSON.stringify({ name: 'email', module: 'share' }, null, 2)}
				>
					<SocialIcon type="email" alt="Share This Page with Email" />
				</EmailShareButton>
			</div>
		);
	}
}

export default SocialShare;
